module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"stat.service.num_close.title":"งานซ่อม","stat.service.num_close.suffix":"งาน","stat.service.num_close.previous":"เดือนที่แล้วมี","stat.service.man_hours.title":"Man-hours","stat.service.man_hours.previous":"เดือนที่แล้วใช้","stat.service.payment.title":"รายได้","stat.service.payment.previous":"เดือนที่แล้วได้"}}')
  delete Component.options._Ctor
}
